import { render, staticRenderFns } from "./UploadedFileDetailsViewer.vue?vue&type=template&id=2546918b&scoped=true"
import script from "./UploadedFileDetailsViewer.vue?vue&type=script&lang=js"
export * from "./UploadedFileDetailsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546918b",
  null
  
)

export default component.exports